import Modal from "react-bootstrap/Modal";

var FA = require('react-fontawesome');

function PendReasonViewer({ isVisible, content, onClose }) {

    const handleClose = () => {
        onClose();
    }

    return(
        <Modal show={isVisible}>
            <Modal.Header className="ps-sm-5 pe-sm-5 pt-sm-4 pb-0">
                <Modal.Title>Pended Reason</Modal.Title>
                <FA name="close" className="cursor-pointer"
                    onClick={handleClose} />
            </Modal.Header>
            <Modal.Body className="ps-sm-5 pe-sm-5 pb-sm-5">
                {content}
            </Modal.Body>
        </Modal>
    );
}

export default PendReasonViewer;